module.exports = __webpack_public_path__ + "static/media/gDesign.81c9d760.png";